import { render, staticRenderFns } from "./IntroLetter.vue?vue&type=template&id=3f8e5fb8&scoped=true&"
import script from "./IntroLetter.vue?vue&type=script&lang=js&"
export * from "./IntroLetter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8e5fb8",
  null
  
)

export default component.exports